<script lang="ts">
  import type { IconsBaseProps } from './icons.types.ts';

  let { class: className, size = 6, title, ...rest }: IconsBaseProps = $props();
</script>

<svg
  viewBox="0 0 24 24"
  {...rest}
  height={size * 4}
  width={size * 4}
  class={className}
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="12" cy="12" r="12" fill="currentColor" />
</svg>
